import setLang from '../lang';

const lang = {
    i: {
        locale: 'zh-CN',
        form_el: {
            test: '请选择',
        },
    }
};

setLang(lang);

export default lang;



// WEBPACK FOOTER //
// ./goingsrc/locale/lang/zh-CN.js